import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import TableCell from 'src/components/Table/TableCell';
import Table from 'src/components/Table';
import NotFoundRecords from 'src/components/NotFoundRecords';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import { LOAD_CONTRACT_ACCOUNTING_INTEREST_BALANCE } from 'src/store/actions/contractActions';
import AccountingInterestBalanceRow from './AccountingInterestBalanceRow';

const Tbody = ({ balanceList }) =>
  balanceList.map((item, index) => (
    <AccountingInterestBalanceRow
      key={`${item.clientId || 'interest'}-${item.contractId || index}`}
      {...item}
    />
  ));

Tbody.propTypes = {
  balanceList: PropTypes.array.isRequired
};

const AccountingInterestBalanceTable = ({ balanceList, ...rest }) => {
  const { t } = useTranslation();
  const loading = useSelector(
    isLoadingSelector([LOAD_CONTRACT_ACCOUNTING_INTEREST_BALANCE.action])
  );

  const theads = useMemo(
    () => () => (
      <TableRow>
        <TableCell variant="head" align="center" sx={{ width: '10%' }}>
          {t('CONTRACT_VIEW.CONTRACT_DETAIL.PERIOD')}
        </TableCell>
        <TableCell variant="head" align="center" sx={{ width: '15%' }}>
          {t('COMMON.DATE')}
        </TableCell>
        <TableCell variant="head" align="center" sx={{ width: '15%' }}>
          {t('INTEREST_BALANCE.INITIAL_BALANCE')}
        </TableCell>
        <TableCell variant="head" align="center" sx={{ width: '15%' }}>
          {t('INTEREST_BALANCE.CONTRACT_DISCHARGE')}
        </TableCell>
        <TableCell variant="head" align="center" sx={{ width: '15%' }}>
          {t('INTEREST_BALANCE.AMORTIZATION')}
        </TableCell>
        <TableCell variant="head" align="center" sx={{ width: '15%' }}>
          {t('INTEREST_BALANCE.INTEREST_CHANGE')}
        </TableCell>
        <TableCell variant="head" align="center" sx={{ width: '15%' }}>
          {t('INTEREST_BALANCE.FINAL_BALANCE')}
        </TableCell>
      </TableRow>
    ),
    [t]
  );

  const tbody = useMemo(() => () => <Tbody balanceList={balanceList} />, [
    balanceList
  ]);

  if (!loading && !balanceList.length) {
    return (
      <Card>
        <NotFoundRecords
          title="NOT_FOUND_RECORDS_MESSAGE.BALANCE_INTEREST_TITLE"
          description="NOT_FOUND_RECORDS_MESSAGE.BALANCE_INTEREST_DESCRIPTION"
        />
      </Card>
    );
  }

  return (
    <Table
      variant="outlined"
      tbody={tbody}
      theads={theads}
      loading={loading}
      {...rest}
    />
  );
};

AccountingInterestBalanceTable.propTypes = {
  balanceList: PropTypes.array.isRequired
};

export default AccountingInterestBalanceTable;
